export const environment = {
    production: true,
    baseUrl: 'https://preprod.api.stat-wisee.srdi.net/',
    apiPath: '',
};